import { useEffect } from 'react';
import { useComponentIsMounted } from './useComponentIsMount';

export function useComponentDidUpdate(
  effect: React.EffectCallback,
  deps: Array<any>
) {
  const isMounded = useComponentIsMounted();

  useEffect(() => {
    if (isMounded) return effect();
  }, deps);
}
